import { EventEmitter } from '@angular/core';
import { SystemService } from '../service/system.service';
var bhiveMapComponent = (function () {
    function bhiveMapComponent() {
        this.systemService = new SystemService();
        this.gMapClick = new EventEmitter();
        this.gMarkerClick = new EventEmitter();
    }
    bhiveMapComponent.prototype.onWindowResize = function () {
        var _this = this;
        this.myMap.triggerResize().then(function () {
            if (_this.lat && _this.lng)
                _this.myMap._mapsWrapper.setCenter({ lat: _this.lat, lng: _this.lng });
        });
    };
    bhiveMapComponent.prototype.ngOnInit = function () {
        this.hideMarker = this.hideMarker ? this.hideMarker : false;
        this.enableHighAccuracy = this.enableHighAccuracy ? this.enableHighAccuracy : false;
        this.mapTimedout = this.mapTimedout ? this.mapTimedout : 10000;
        this.mapZoom = this.mapZoom ? this.mapZoom : 20;
        this.markerSize = this.markerSize ? this.markerSize : 40;
        this.usePanning = this.usePanning ? this.usePanning : false;
        this.markerTraggerble = this.markerTraggerble ? this.markerTraggerble : false;
        this.getLocation();
    };
    bhiveMapComponent.prototype.markerEventEmitter = function (event) {
        this.gMarkerClick.emit(event);
    };
    bhiveMapComponent.prototype.getLocation = function () {
        var _this = this;
        if (this.systemService.deviceType == 'browser') {
            navigator.geolocation.getCurrentPosition(locationSuccess);
        }
        else {
            getCurrentLocation();
        }
        function getCurrentLocation() {
            navigator.geolocation.getCurrentPosition(locationSuccess, locationError, { enableHighAccuracy: this.enableHighAccuracy, timeout: _this.mapTimedout });
        }
        function locationSuccess(position) {
            _this.lat = position.coords.latitude;
            _this.lng = position.coords.longitude;
            _this.getGeoLocation(_this.lat, _this.lng);
        }
        function locationError(error) {
            window['cordova'].plugins.diagnostic.isLocationEnabled(function (enabled) {
                if (enabled) {
                }
                else {
                    window['cordova'].plugins.diagnostic.switchToLocationSettings();
                    window['cordova'].plugins.diagnostic.registerLocationStateChangeHandler(function () {
                        getCurrentLocation();
                    });
                }
            }, function () {
            });
        }
    };
    bhiveMapComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        if (this.iconUrl) {
            this.imageDetect(this.iconUrl).then(function (url) {
                _this.updateImageUrl(url);
            }).catch(function (error) {
                //this.updateImageUrl(error);
            });
        }
        else {
            //this.updateImageUrl(null);
        }
    };
    bhiveMapComponent.prototype.marker = function (event) {
        this.lat = event.coords.lat;
        this.lng = event.coords.lng;
        this.getGeoLocation(this.lat, this.lng);
    };
    bhiveMapComponent.prototype.getGeoLocation = function (lat, lng) {
        var _this = this;
        var latlng = new google.maps.LatLng(lat, lng);
        var geocoder = geocoder = new google.maps.Geocoder();
        geocoder.geocode({ 'latLng': latlng }, function (results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
                if (results[1]) {
                    _this.formattedAddress = true;
                    _this.formattedAddress = results[1].formatted_address;
                }
                else {
                    _this.formattedAddress = false;
                }
            }
            else {
                _this.formattedAddress = false;
            }
        });
    };
    bhiveMapComponent.prototype.mapClicked = function (event) {
        this.gMapClick.emit(event);
        this.lat = event.coords.lat;
        this.lng = event.coords.lng;
        this.getGeoLocation(this.lat, this.lng);
    };
    bhiveMapComponent.prototype.imageDetect = function (url) {
        return new Promise(function (resolve, reject) {
            var image = new Image();
            image.src = url;
            image.onload = function () {
                resolve(url);
            };
            image.onerror = function () {
                reject(false);
            };
        });
    };
    bhiveMapComponent.prototype.updateImageUrl = function (url) {
        this.iconConfiguration = {
            url: url,
            scaledSize: {
                height: this.markerSize,
                width: this.markerSize
            }
        };
    };
    return bhiveMapComponent;
}());
export { bhiveMapComponent };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/mapComponent/map.component.ts.pre-build-optimizer.js